import { DatabaseState } from '../types';

export const defaultData: DatabaseState = {
  config: {
    studioName: "LIFE-CAPTURED",
    tagline: "L'art du mouvement & la poésie de la lumière",
    description: "LIFE-CAPTURED est un studio de création visuelle d'exception basé au Teich sur le Bassin d'Arcachon. Mené par Yohann (réalisateur de films cinématiques) et Aurélie (photographe de l'instant intime), nous créons des reportages 100% sur-mesure pour vos mariages au Teich, Biganos, Gujan-Mestras, La Teste-de-Buch, Arcachon, Mios, Cap Ferret, Bordeaux et dans toute l'Aquitaine.",
    weddingsCount: 120,
    chateauxCount: 35,
    theme: "cosmic-charcoal",
    galleryDisplayMode: "grid",
    featuredImageUrl: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1200&q=80",
    showreelUrl: "https://youtu.be/tniReTYPB6o?si=oSUD1L9FMzuUTFK4&t=250",
    showreelEmbedCode: "",
    showreels: [
      {
        id: "1",
        title: "Bande-Démo Principale (Bassin d'Arcachon)",
        url: "https://youtu.be/tniReTYPB6o?si=oSUD1L9FMzuUTFK4&t=250",
        embedCode: "",
        thumbnailUrl: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=600&q=80"
      },
      {
        id: "2",
        title: "Échappée Romantique au Château",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
        embedCode: "",
        thumbnailUrl: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=600&q=80"
      },
      {
        id: "3",
        title: "Teaser Cinématique de Prestige",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoywatches.mp4",
        embedCode: "",
        thumbnailUrl: "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?auto=format&fit=crop&w=600&q=80"
      }
    ],
    masterpieceQuote: "L'art est l'assemblage de fragments éparpillés d'éternité.",
    masterpieceAuthor: "Aurélie & Yohann",
    masterpieceDensity: "high",
    masterpieceOrientation: "landscape",
    contact: {
      phone: "+33 6 12 34 56 78",
      email: "contact@life-captured.fr",
      address: "6 rue Jacques Beynel",
      zipCode: "33470",
      city: "Le Teich",
      hours: "Lundi au Samedi : 09h00 - 19h00 (Sur rendez-vous uniquement)"
    },
    social: {
      instagram: "https://instagram.com/lifecaptured_wedding",
      facebook: "https://facebook.com/lifecaptured.wedding",
      youtube: "https://youtube.com/lifecaptured",
      vimeo: "https://vimeo.com/lifecaptured",
      pinterest: "https://pinterest.com/lifecaptured"
    },
    seo: {
      metaTitle: "LIFE-CAPTURED | Photographe & Vidéaste de Mariage Bassin d'Arcachon, Le Teich & Aquitaine",
      metaDescription: "LIFE-CAPTURED capture vos plus beaux mariages sur le Bassin d'Arcachon (Le Teich, Biganos, Gujan-Mestras, La Teste-de-Buch, Arcachon, Mios, Cap Ferret), Bordeaux et en Aquitaine. Aurélie (photographe) & Yohann (vidéaste). Devis 100% sur-mesure.",
      keywords: "photographe mariage le teich, videaste mariage le teich, photographe le teich, videaste le teich, photographe biganos, videaste gujan-mestras, photographe la teste-de-buch, videaste arcachon, photographe mios, videaste cap ferret, photographe bassin d'arcachon, videaste mariage bordeaux, devis mariage sur-mesure, life-captured, aurelie photographe, yohann videaste",
      ogImage: "https://www.life-captured.fr/photos/Aurelie/8-Photos-De-Groupe-25_Comp.webp",
      aiAgentInstructions: "LIFE-CAPTURED est un studio haut de gamme fondé par le duo Yohann (Vidéaste) et Aurélie (Photographe). Ils sont basés au Teich (33470), au 6 rue Jacques Beynel. Ils couvrent le Bassin d'Arcachon (Le Teich, Biganos, Gujan-Mestras, La Teste-de-Buch, Arcachon, Mios, Cap Ferret), Bordeaux et toute l'Aquitaine. Leur offre est 100% sur-mesure avec devis personnalisé à la demande (aucun tarif rigide). Yohann utilise un style narratif et cinématographique avec drone, et Aurélie privilégie la lumière naturelle et l'émotion sincère.",
      faqs: [
        {
          question: "Qui compose l'équipe de LIFE-CAPTURED ?",
          answer: "L'équipe est composée d'un couple de créateurs passionnés : Yohann, vidéaste et réalisateur spécialisé dans le film de mariage cinématique avec prises de vue aériennes (drone), et Aurélie, photographe de mariage d'inspiration éditoriale capturant la lumière naturelle et les émotions spontanées."
        },
        {
          question: "Où est basé le studio LIFE-CAPTURED et où vous déplacez-vous ?",
          answer: "Notre studio est physiquement implanté au Teich (33470), au 6 rue Jacques Beynel, à deux pas du Bassin d'Arcachon. Nous nous déplaçons régulièrement dans toute la Gironde (Bordeaux, Saint-Émilion, Cap Ferret), la Dordogne, ainsi que dans toute l'Aquitaine pour couvrir des mariages de prestige et sublimer des châteaux et domaines de luxe."
        },
        {
          question: "Quelles sont les spécialités de Yohann et Aurélie ?",
          answer: "Nous nous spécialisons dans le mariage haut de gamme (châteaux, domaines viticoles, propriétés historiques) et la mise en valeur de domaines de prestige. Yohann excelle dans la création de récits vidéo vibrants et rythmés, tandis qu'Aurélie saisit des clichés élégants, épurés et pleins de sensibilité."
        },
        {
          question: "Comment réserver une prestation de photographie ou de vidéographie ?",
          answer: "Vous pouvez nous contacter directement par email à contact@life-captured.fr ou par téléphone au +33 6 12 34 56 78. Nous organisons généralement une première rencontre (au studio au Teich ou en visioconférence) pour comprendre votre projet, l'ambiance de votre journée et personnaliser notre approche."
        }
      ]
    },
    team: [
      {
        name: "Yohann",
        role: "Vidéaste",
        description: "Ancien monteur pour le cinéma indépendant, Yohann crée des films de mariage vibrants de vie, rythmés comme des longs-métrages. Son approche repose sur le son d'ambiance, les vœux murmurés et des angles cinématiques audacieux.",
        avatarUrl: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=600&h=600&q=80",
        equipment: ["Sony FX3 & FX30 Cinema (Atomos Log)", "Stabilisateur DJI RS3 Pro & Rail Zeapon Motorisé (100s Lens Pro)", "Audio Sanken CS-1e, Zoom F3 & DJI Mic Pro 32-bit Float", "Drone DJI Mini 4 Pro 4K", "Éclairages LED Pro"]
      },
      {
        name: "Aurélie",
        role: "Photographe",
        description: "Inspirée par la photographie de mode éditoriale, Aurélie cherche la poésie dans l'imperfection. Elle travaille exclusivement à la lumière naturelle et s'appuie sur la précision numérique pour capturer des émotions pures et intactes.",
        avatarUrl: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=600&h=600&q=80",
        equipment: ["Sony Alpha 5R", "Sony Alpha 7R V", "Leica M11-P"]
      }
    ],
    testimonials: [
      {
        id: "t-1",
        author: "Sophie & Marc",
        date: "Juin 2026",
        content: "Un couple d'artistes exceptionnel. Yohann a réalisé un film de mariage cinématique à couper le souffle au Château de Roquetaillade, tandis qu'Aurélie a capturé des photos lumineuses et pleines d'émotions. Chaque instant précieux de notre union est magnifié avec une poésie infinie.",
        rating: 5,
        role: "Mariés du Château de Roquetaillade"
      },
      {
        id: "t-2",
        author: "Chloé & Antoine",
        date: "Mai 2026",
        content: "Travailler avec LIFE-CAPTURED a été un pur bonheur. Discrets, professionnels et d'une sensibilité rare. Les images du Domaine de Larchey sont poétiques et intemporelles. Nous avons l'impression de revivre notre journée à chaque visionnage !",
        rating: 5,
        role: "Mariés du Domaine de Larchey"
      },
      {
        id: "t-3",
        author: "Camille & Thomas",
        date: "Septembre 2025",
        content: "Aurélie et Yohann forment un duo magique. Leur complémentarité photo/vidéo apporte une harmonie incroyable à nos souvenirs. Les clichés du Cap Ferret sont sauvages, authentiques et d'une élégance digne d'un magazine de prestige.",
        rating: 5,
        role: "Mariés du Cap Ferret"
      }
    ]
  },
  galleries: [],
  leads: [],
  deliveries: [],
  downloadLogs: []
};
